<template>
  <footer class="container-fluid py-2 bg-light mt-auto" >
    <div class="d-flex align-items-center justify-content-between small">
      <div class="text-muted">Copyright &copy; KRBS CIRCULAR 2022</div>
      <div>
        <a href="#">Privacy Policy</a>
        &middot;
        <a href="#">Terms &amp; Conditions</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'BaseAppFooter',
};
</script>

<style scoped>
footer {
  margin-top: auto;
}

</style>
